import { useMutation, useQueryClient } from '@tanstack/react-query';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';
import type { ParentFormValues } from '~shared/types/schema';

export interface CreateParentWithoutStripeParams extends ParentFormValues {
  contactId: string;
  studioId: string;
  familyName: string;
  registration?: boolean;
  isCreatedFromStudio?: boolean;
}

export interface CreatedParentWithoutStripe {
  _id: string;
  firstName?: string;
  lastName?: string;
  name?: string;
  email?: string;
  primaryPhone?: string;
}

export const createParentWithoutStripe = async (
  params: CreateParentWithoutStripeParams,
) => {
  const response = await baseAPI.post<CreatedParentWithoutStripe>(
    '/parents',
    params,
  );

  return response.data;
};

export const useCreateParentWithoutStripeMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createParentWithoutStripe,
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: [KEYS.PARENTS_LIST, KEYS.STUDIO],
      });
    },
  });
};
